module.exports = __webpack_public_path__ + "static/media/1-13.fcd3d8ca.mp3";